// God-mode entry point — ONLY used by the god build (REACT_APP_GODMODE=1).
// craco swaps the webpack entry to this file, so god code never enters the
// public bundle. Served by the internal localhost-only nginx (SSM tunnel).
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { Toaster } from "sonner";
import GodApp from "@/godmode/GodApp";

document.title = "SuperCash";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Toaster position="top-right" theme="dark" />
    <GodApp />
  </React.StrictMode>,
);
